const evaluationDetails = resolve => require(['@/page/fillManagement/evaluationDetails.vue'], resolve);
export default {
  path: '/home/fillManagement/details/evaluation',
  component: evaluationDetails,
  meta: {
    title: '学生过程性评价详情',
    path: '/home/fillManagement/details',
    breadList: [
      {
        title: '首页',
        path: '/homePage'
      },
      {
        title: '大连学业水平质量抽测填报',
        path: '/home/fillManagement'
      },
      {
        title: '项目详情',
        path: '/home/fillManagement/details',
      },
      {
        title: '学生过程性评价详情',
        path: '/home/fillManagement/details/evaluation',
      }
    ]
  },
}



// WEBPACK FOOTER //
// ./src/router/fillManagement/evaluationDetails.js